<!-- 文件管理 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <purchaseOrderAction v-if="showStatus" ref="purchaseOrderAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></purchaseOrderAction>
    </el-drawer>

    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
        </v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row size="mini">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <!-- 主表格 -->
        <el-table-column v-if="tableValye.isShow==1" align="center" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
          :min-width="tableValye.fieldWeight" :label="tableValye.showField">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
              {{scope.row.isWms == 0 ? '否' : '是'}}
            </el-tag>
            <span v-else-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
            </span>
            <span v-else>
              {{scope.row[tableValye.entityField]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <upFile ref="upFile"></upFile>
    <!-- 合同 -->
    <el-dialog :title="'查看'+upType" :visible.sync="diaContract" width="800px">
      <el-button type="primary" size="mini" @click="downLoadFile" :disabled="urls.length == 0" style="margin-bottom:10px">批量下载</el-button>
      <el-table size="mini" :data="urls" border style="width: 100%" height="300">
        <el-table-column prop="bgmName" show-overflow-tooltip label="通用名称">
        </el-table-column>
        <el-table-column prop="codingNum" show-overflow-tooltip label="编码"></el-table-column>
        <el-table-column prop="busType" show-overflow-tooltip label="业务类型"></el-table-column>
        <el-table-column prop="createrName" show-overflow-tooltip label="上传人"></el-table-column>
        <el-table-column prop="createTime" show-overflow-tooltip label="上传时间">
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">
              {{$common.getLocalTime(scope.row.createTime)}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" show-overflow-tooltip label="文件名"></el-table-column>
        <el-table-column prop="fileType" show-overflow-tooltip label="文件类型"></el-table-column>
        <el-table-column prop="fileUrl" show-overflow-tooltip label="附件">
          <template slot-scope="scope">
            <cusImage style="width: 30px;height: 30px;" v-if="scope.row.type == '图片'" :src="$common.getFileAddress(scope.row.fileUrl)" :preview-src-list="[$common.getFileAddress(scope.row.fileUrl)]"></cusImage>
          </template>
        </el-table-column>
        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <div class="imgs">
              <el-link @click="downLoadImg(scope.row.fileUrl)" type="primary" :underline="false" style="margin-left:10px">另存为</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import purchaseOrderAction from "@/components/purchaseOrderAction.vue";
import upFile from '@/components/upFile.vue'
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    purchaseOrderAction,
    upFile
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        businessId: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        cmId: "",
        cmName: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,
      seId: "",
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      isShowTooltip: false,
      showStatus: false,
      actionData: {},
      fileSelect: '',
      diaContract: false, //合同
      diaInspectionReport: false, // 检验报告
      diaInvoice: false, // 发票
      diaWithCar: false, // 随货同行
      multipleSelection: [],
      fileIds: [], //明细id数组 明细单号
      busynessKey: [], //记账单号
      fileData: [],
      diaTitle: '上传合同',
      upType: 1,
      url: require('@/assets/img/other/look.png'),
      srcList: [],
      requesUrl: '',
      imgUrl: '',
      fileType: [{
        key: 1,
        value: '图片'
      },
      {
        key: 2,
        value: '文件'
      },
      {
        key: 3,
        value: '视频'
      },
      {
        key: 4,
        value: '音频'
      },
      {
        key: 5,
        value: '未识别'
      },
      ],
      urls: [],
      parentSearchData: {},
      sField: ''

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.cmName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.cmId = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    print() {
      this.$print(document.getElementById('prr'))
    },
    //批量下载压缩包
    async downLoadFile(e) {
      window.location.href = this.requesUrl + '/woApply/downOrderFileZip?busynessId=' + this.fileIds.toString() +
        '&&busynessType=' + this.upType
    },
    //单个下载文件
    downLoadImg(e) {
      window.location.href = this.requesUrl + '/psaccount/downDetailFile?url=' + e
    },
    //  查看图片
    lookImg(row) {
      this.srcList = []
      var arr = row.fileUrl.split(',')
      arr.forEach(item => {
        this.srcList.push(this.imgUrl + '/' + item)
      })
    },
    //  打开文件上传组件
    openFile() {
      this.$refs['upFile'].openFileDia()
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 子组件触发
    drawerCancel(e) {
      this.showStatus = false;
      if (e == 1) this.getDataList();
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({
          //向窗口发送MessageEvent消息
          cmd: "returnFormJson",
          params: {
            isPenetrate
          }, //参数
        },
          "*"
        );
      }
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
      // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },

    getSearchName(e) {
      this.seTitle = e;
    },

    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[type] = this.getRequestData[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
        this.getButtonList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 8:
          this.showPrintPlan()
          break
        case 11:
          this.upType = '合同'
          this.getFileListByIds()
          break;
        case 12:
          this.upType = '检验报告'
          this.getFileListByIds()
          break;
        case 13:
          this.upType = '发票'
          this.getFileListByIds()
          break;
        case 14:
          this.upType = '随货同行'
          this.getFileListByIds()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    showPrintPlan() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.fileIds = []
      this.multipleSelection.forEach(item => {
        this.fileIds.push(item.businessId)
      })
      var pathId = parent.getMenuInfo('/woapplyFileList')
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        // this.$refs.printPlan.openDia(this.fileIds, '', pathId.jurId, '', '', '', 'someUserData')
        this.$refs.printPlan.openDia(this.fileIds, 'printData/suOrderBookkeeping', sessionStorage.getItem('printJurId'), '', 'all')
      } else {
        return
      }
    },
    // 通过明细id查询文件列表
    async getFileListByIds() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.urls = []
      this.fileIds = []
      this.busynessKey = []
      this.multipleSelection.forEach(item => {
        this.fileIds.push(item.dasmId)
      })
      let params = {
        dasmId: this.fileIds,
        fileType: this.upType
      }
      let responseData = await this.$http.queryWarehousingFileSales(params);
      if (responseData.status == 200) {
        responseData.result.forEach(item => {
          this.urls.push(
            item
          )
        })
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
      this.diaContract = true
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryWoapplyFile(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
// 按钮排序
//获取图片存取的根路径
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.imgurl()
    this.getPageInfo();

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-drawer {
  outline: none;
}

.fileTable {
  margin-top: 10px;
}

.el-link {
  font-size: 12px !important;
}

.imgs {
  display: flex;
  align-items: center;
}

::v-deep.el-image img {
  margin-top: 2px;
}
</style>